import React from "react";
import styled from "styled-components";

import { MoreIcon } from "assets/icons";
import { Popover } from "ui/components/styled";
import { FixedElementsContextProvider } from "ui/context/fixedElements/FixedElementsContext";
import { ActionButton } from "./styled";

const MoreActionsPopup = styled(Popover)`
  .popover-content {
    padding: 8px 0;
    box-shadow: rgba(0, 0, 0, 0.25) 0 0 4px;
  }
`;

interface MoreActionsProps {
  renderContent: (close: () => void, isOpen: boolean) => React.ReactNode;
}
export const MoreActions = (props: MoreActionsProps) => {
  const { renderContent } = props;

  return (
    <FixedElementsContextProvider>
      <MoreActionsPopup
        placement="top-end"
        renderContent={renderContent}
        renderTrigger={() => (
          <ActionButton aria-label="More actions" title="More actions">
            <MoreIcon />
          </ActionButton>
        )}
      />
    </FixedElementsContextProvider>
  );
};
